if (!customElements.get('tc-review-carousel')) {
  customElements.define('tc-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.tc-reviews__track');
      this.slides = [...this.querySelectorAll('.tc-review')];
      this.controls = this.querySelector('.tc-reviews__controls');
      this.previous = this.querySelector('[data-review-previous]');
      this.next = this.querySelector('[data-review-next]');
      this.status = this.querySelector('[data-review-status]');
      if (!this.slides.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.controls.hidden = this.slides.length < 2;
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), options);
      this.track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    get index() {
      return Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
    }
    move(direction) {
      const index = Math.max(0, Math.min(this.slides.length - 1, this.index + direction));
      this.track.scrollTo({left: index * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    update() {
      const index = this.index;
      this.previous.disabled = index === 0;
      this.next.disabled = index === this.slides.length - 1;
      this.status.textContent = this.status.dataset.label.replace('[current]', index + 1).replace('[total]', this.slides.length);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
